import {
  SEARCH_FUNDS_REQUEST,
  SEARCH_FUNDS_SUCCESS,
  RESET_SUGGESTIONS,
  statusType
} from '../../actions'

const initial = {
  suggestions: [],
  status: statusType.IDLE
}

const fund = (state = initial, action) => {
  switch (action.type) {
    case SEARCH_FUNDS_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case SEARCH_FUNDS_SUCCESS:
      return {
        ...state,
        suggestions: action.payload || [],
        status: statusType.SUCCESS
      }

    case RESET_SUGGESTIONS:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default fund
